// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"695":"6e502b2d","4041":"5e0fd2d5"}[chunkId] + ".chunk.css";
};